<template>
    <div class="recruitRule">
        <div class="openRecruit">
            <div class="title">开启招募<i class="el-icon-info"></i></div>
            <div class="recruitSetting">
                <div class="openCloseBtn">
                    <el-radio v-model="params.isopenrecruit" :label="1">
                        <span>开启</span>
                    </el-radio>
                    <span class="tips">开启后，用户可申请成为推广员</span>
                    <br>
                    <el-radio v-model="params.isopenrecruit" :label="0">
                        <span>关闭</span>
                    </el-radio>
                    <span class="tips">关闭后，用户不可申请成为推广员</span>
                </div>
                <div class="joinConditionBox" v-if="params.isopenrecruit">
                    <div class="title">加入条件</div>
                    <div class="joinCondition">
                        <div class="conditionChoice">
                            <el-radio v-model="params.isjoincondition" :label="1">
                                <span>有条件</span>
                            </el-radio>
                            <span class="tips">有条件时，用户需要先满足条件，才可申请</span>
                            <br>
                            <el-radio v-model="params.isjoincondition" :label="0">
                                <span>无条件</span>
                            </el-radio>
                            <span class="tips">无条件时，所有用户可申请</span>
                        </div>
                        <div class="haveConditionTips" v-if="params.isjoincondition">
                            <span class="title">增加条件</span>
                            <span class="condition">需购买任意课程</span>
                            <span class="tips">凡购买过商品的用户，即可申请成为推广员。不选表示：所有用户可申请</span>
                        </div>
                    </div>
                </div>
                <div class="recruitAuditBox" v-if="params.isopenrecruit">
                    <div class="title">招募审核</div>
                    <div class="recruitAudit">
                        <el-radio v-model="params.isauthpromoter" :label="1">
                            <span>开启</span>
                        </el-radio>
                        <span class="tips">开启后，用户申请推广员，需要商家审核</span>
                        <br>
                        <el-radio v-model="params.isauthpromoter" :label="0">
                            <span>关闭</span>
                        </el-radio>
                        <span class="tips">关闭后，满足条件的用户可成为推广员，无需商家审核</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="developSubordinateBox">
            <div class="title">发展下级</div>
            <div class="developSubordinateBtn">
                <div class="developSubordinate">
                    <el-radio v-model="params.isnextpromoter" :label="1">
                        <span>开启</span>
                    </el-radio>
                    <span class="tips">开启后，所有推广员可邀请好友成为推广员；被邀请方成功推广后，邀请方会获得“间接推广佣金”。最多2级</span>
                    <br>
                    <el-radio v-model="params.isnextpromoter" :label="0">
                        <span>关闭</span>
                    </el-radio>
                    <span class="tips">关闭后，所有推广员不可邀请好友成为推广员，已存在的邀请关系不受影响</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'recruitRule',
    data() {
        return {
            recruit: '1',
            joinCondition: '2',
            recruitAudit: '1',
            developSubordinate: '1',
            params: {
                isopenrecruit: 1,
                conditiontype: 1,
                isjoincondition: 0,
                isauthpromoter: 1,
                isnextpromoter: 1
            }
        }
    },
    props: ['data'],
    created() {
    },
    watch: {
        'data': {
            handler() {
                for (let key in this.params) {
                    this.params[key] = this.data[key]
                }
            },
            deep: true
        }
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import '~common/scss/mixin';
    .recruitRule{
        width: 1110px;
        .openRecruit{
            display: flex;
            .recruitSetting{
                width: 1000px;
                margin-left: 40px;
                .openCloseBtn{
                    border-bottom: 1px solid #DCDFE6;
                    padding-bottom: 20px;
                }
                .joinConditionBox{
                    display: flex;
                    margin-top: 20px;
                    .joinCondition{
                        flex: 1;
                        .conditionChoice{
                            padding-bottom: 20px;
                            border-bottom: 1px solid #DCDFE6;
                        }
                        .haveConditionTips{
                            padding: 20px 0;
                            border-bottom: 1px solid #DCDFE6;
                            font-size: 14px;
                            .title{
                                margin-right: 40px;
                                color: #606266;
                            }
                            .condition{
                                margin-right: 20px;
                                color: #303133;
                            }
                            .tips{
                                color: #909399;
                                font-size: 12px;
                            }
                        }
                    }
                }
                .recruitAuditBox{
                    display: flex;
                    margin-top: 20px;
                    border-bottom: 1px solid #DCDFE6;
                    padding-bottom: 20px;
                }
            }
        }
        .developSubordinateBox{
            display: flex;
            margin-top: 30px;
            // line-height: 60px;
            .developSubordinateBtn{
                margin-left: 60px;
            }
        }
        .title{
            color: #606266;
            width: 74px;
            padding-top: 10px;
        }
        .el-radio{
            margin-top: 18px;
            margin-right: 20px
        }
        .el-radio__input.is-checked+.el-radio__label {
            color: #303133;
        }
        .tips{
            color: #909399;
        }
    }
</style>